import _ from 'lodash';
import { httpNoAuth } from '@/utils/axios';

const init = () => ({
  memberTypes: [],
  scoringEvents: [],
  playerMovements: [],
  modules: {
    indvCompetitions: undefined,
    competitions: undefined,
    events: undefined,
    memberships: undefined,
    additionalQs: undefined,
    saleableItems: undefined,
    entityMemberships: undefined,
    clubMemberships: undefined,
    customFees: undefined,
    bookings: undefined,
    quickResults: undefined,
  },
  seasons: [],
  presentation: {
    useExplorer: false,
    showLogo: false,
    nationalDirectChild: 'states',
    stateDirectChild: 'associations',
    associationDirectChild: 'clubs',
  },
  entity: {
    _id: undefined,
    level: undefined,
    name: undefined,
  },
  timezone: 'Australia/Sydney',
});

export default {
  namespaced: true,
  state: init(),
  mutations: {
    updateModules(state, payload) {
      state.modules = payload;
    },
    updateMemberTypes(state, payload) {
      state.memberTypes = payload;
    },
    updateScoringEvents(state, payload) {
      state.scoringEvents = payload;
    },
    updatePlayerMovements(state, payload) {
      state.playerMovements = payload;
    },
    updateSeasons(state, payload) {
      state.seasons = payload;
    },
    updateTimezone(state, payload) {
      state.timezone = payload;
    },
    updatePresentation(state, payload) {
      console.log({ payload });
      state.presentation = { ...payload };
      console.log('state.presentation', state.presentation);
    },
    setMeta(state, payload) {
      state.meta = payload.meta;
      state.entity._id = payload._id;
    },
    setEntity(state, payload) {
      state.entity = payload.entity;
    },
    resetCustom(state) {
      // reset to default use assign instead of replacing the object
      _.assign(state.meta, {
        primaryColor: undefined,
        secondaryColor: undefined,
        imgUrl: undefined,
        name: undefined,
        slug: undefined,
      });
      _.assign(state.entity, {

        _id: undefined,
        level: undefined,
        name: undefined,
      });
      document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
      document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
    },
  },
  actions: {
    async setup({ commit }) {
      try {
        const resPresentation = await httpNoAuth.get('assemble/api/v1/live/nationals/presentation');
        const resEvents = await httpNoAuth.get('assemble/api/v1/live/nationals/events');
        const resSeasons = await httpNoAuth.get('assemble/api/v1/live/seasons');
        const resModules = await httpNoAuth.get('assemble/api/v1/live/nationals/modules');
        if (resSeasons.data.seasons) {
          commit('updateSeasons', resSeasons.data.seasons);
        }
        if (resPresentation.data.livescore) {
          commit('updatePresentation', resPresentation.data.livescore);
        }
        if (resEvents.data.scoringEvents) {
          commit('updateScoringEvents', resEvents.data.scoringEvents);
        }
        if (resEvents.data.playerMovements) {
          commit('updatePlayerMovements', resEvents.data.playerMovements);
        }
        if (resEvents.data.timezone) {
          commit('updateTimezone', resEvents.data.timezone);
        }
        if (resModules.data.modules) {
          commit('updateModules', resModules.data.modules);
        }
      } catch (error) {
        console.error('Error setting up store:', error);
        throw error; // Rethrow or handle as needed
      }
    },
    async getSlugBranding({ commit }, slugs) {
      try {
        const resMetaSlug = await httpNoAuth.get('assemble/api/v1/portal/national/get/slug-details', // add the slug to the url
          {
            params: {
              slugs,
            },
          });
        if (resMetaSlug.data.data) {
          const { meta, _id, entityLevel, name } = resMetaSlug.data.data;
          if (meta) {
            if(name) meta.name = name;
            await commit('setMeta', { meta, _id });
            await commit('setEntity', { entity: { _id, level: entityLevel, name: slugs.entityName } });
            document.documentElement.style.setProperty('--highlight-color', meta.primaryColor);
            document.documentElement.style.setProperty('--secondary-color', meta.secondaryColor);
            return { success: true, entity: { _id, level: entityLevel, name: slugs.entityName } };
          } else {
            document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
            document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
            return { success: false, error: 'No meta data found' };
          }
        }
        return { success: false, error: 'No data found' };
      } catch (error) {
        console.error('Error fetching entity branding:', error);
        document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
        document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
        return { success: false, error };
      }
    }
  },
  getters: {
    memberTypes(state) {
      return _.get(state, 'memberTypes');
    },
    playingMemberTypes(state) {
      return _.filter(_.get(state, 'memberTypes'), t=> t.playing === true);
    },
    nonplayingMemberTypes(state) {
      return _.filter(_.get(state, 'memberTypes'), t=> t.playing !== true);
    },
    scoringEvents(state) {
      return state.scoringEvents;
    },
    playerMovements(state) {
      return state.playerMovements;
    },
    seasons(state) {
      return state.seasons;
    },
    timezone(state) {
      return state.timezone;
    },
    presentation(state) {
      return state.presentation;
    },
    getMeta(state) {
      return state.meta;
    },
    getEntity(state) {
      return state.entity;
    },
    modules(state) {
      return state.modules;
    },

  },
};

